import { ApsPlanStatusSpec, EnumValueSettings, ErpOrderStatusSpec, MesOrderStatusSpec, PlanTypeSpec, SaleOrderStatusSpec, ShiftTaskStatusSpec } from '@tap/data-providers';
import { ValueProps } from './values.types';
import { Typography } from '@mui/material';

type EnumSpec = {
    [key: string]: {
        name: string,
    },
}

const enumSourceDict: { [key: string]: EnumSpec } = {
    apsPlanType: PlanTypeSpec,
    apsPlanStatus: ApsPlanStatusSpec,
    shiftTaskStatus: ShiftTaskStatusSpec,
    erpOrderStatus: ErpOrderStatusSpec,
    saleOrderStatus: SaleOrderStatusSpec,
    mesOrderStatus: MesOrderStatusSpec,
}

const getEnumText = (value: string, dict: EnumSpec) => {
    return dict[value]?.name ?? value;
}

export type EnumValueProps = ValueProps<string, EnumValueSettings> & {
    enumDict?: { [key: string]: EnumSpec },
}

export const EnumValue = ({ value, enumDict = {}, settings = {} }: EnumValueProps) => {

    const { emptyText = '-', dictName = '' } = settings;

    if (value === undefined || value === null) {
        return (
            <Typography>{emptyText}</Typography>
        );
    }

    const dict = enumSourceDict[dictName] ?? enumDict[dictName] ?? {};

    return (
        <Typography>{getEnumText(value, dict)}</Typography>
    );
}